import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChargePointListChannelsCell } from './charge-point-list-channels';
import { ChargePointListChannelsHeader } from './charge-point-list-channels.header';

export const ChargePointListChannelsColumn: IdentifiedColumnDef<
  GatewayChargePointModel,
  GatewayChargePointModel['channels']
> = {
  enableSorting: false,
  header: ChargePointListChannelsHeader,
  cell: ChargePointListChannelsCell,
};
